import React, { useState, useEffect } from "react";
import Footer from "components/Footers/Footer";
import IndexNavbar from "components/Navbars/IndexNavbar";
import servicebg from "assets/img/servicebg.jpg";
import rippedpaper from "assets/img/rippedpaper.png";
import girl1 from "assets/img/girl1.jpg";
import organicservice from "assets/img/organicservice.jpg";
import servicesbg2 from "assets/img/servicebg2.png";
import basket from "assets/img/basket1.png";
import eggs from "assets/img/eggs.png";
import nuts from "assets/img/nuts.png";
import Slider3 from "./Slider3";
import line from "assets/img/line.png";
import process1 from "assets/img/process-1.jpg";
import process2 from "assets/img/process-2.jpg";
import process3 from "assets/img/process-3.jpg";
import darkgreenbg from "assets/img/darkgreenbg.jpg";
import leaf from "assets/img/leaf.png";
import house from "assets/img/house.png";
import grapes from "assets/img/grapes.png";
import gril2 from "assets/img/girl2.png";
import newbg from "assets/img/newbg.jpg";
import conveying from "assets/img/conveying.png";
import mixing from "assets/img/mixing.png";
import thermal from "assets/img/thermal.jpg";
import bgg1 from "assets/img/bgg1.png";
import juice from "assets/img/juice.png";
import bevarages from "assets/img/bevarages.png";
import waterplants from "assets/img/waterplants.png";
import personalcare from "assets/img/personalcare.png";
import cosmetics from "assets/img/cosmetics.png";
import culinary from "assets/img/culinary.png";
import chocolates from "assets/img/chocolates.png";
import oil from "assets/img/oil.png";
import biscuits from "assets/img/biscuits.png";
import medicine from "assets/img/medicine.png";
import spices from "assets/img/spices.png";
import chemicals from "assets/img/chemicals.png";
import service1 from "assets/img/service1.png";
import service2 from "assets/img/service2.png";
import service3 from "assets/img/service3.png";
import { Form } from "formik";
import Popup from "./Popup";
import innovation from "assets/img/innovation.webp";

const Service = () => {
  const [buttonPopup, setButtonPopup] = useState(false);

  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [hovered3, setHovered3] = useState(false);
  const [hovered4, setHovered4] = useState(false);
  return (
    <section className="poppins">
      <IndexNavbar />
      <section className="xl:pt-0 lg:pt-0 md:pt-24 pt-20">
        <div
          className="relative xl:h-400 lg:h-300 md:h-240 h-200-px"
          style={{
            backgroundImage: `url(${bgg1})`,
            width: "100%",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
          {/* Black Overlay */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.6)",
            }}
          ></div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="xl:gap-0">
              <div className="xl:pt-32 lg:pt-24 md:pt-20 pt-16">
                <h1 className="xl:text-7xl lg:text-5xl md:text-4xl text-4xl text-center text-white uppercase font-bold fade-item-1">
                  Services
                </h1>

                <div>
                  <div className="flex items-center justify-center bg-[#FDF5E6] rounded-lg xl:mt-6 lg:mt-4 mt-4">
                    <div
                      className="xl:w-2/12 lg:w-2/12 md:w-2/12 py-2 px-2 flex items-center gap-2 justify-center fade-item-2"
                      style={{ border: "1px dashed white" }}
                    >
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        <a href="/homepage1">Home</a>
                      </span>
                      <span className="text-white font-semibold"> »</span>
                      <span className="text-white xl:text-lg lg:text-lg font-semibold">
                        Services
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:pt-16 lg:pt-16 md:pt-16 pt-12">
        <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-1 container mx-auto xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4">
          <div className="h-full">
            <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
              <div className="relative ">
                <img
                  className="xl:w-12/12 lg:w-12/12 w-12/12"
                  src={conveying}
                  alt=""
                />
                <div
                  className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-4 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                  style={{ position: "relative", zIndex: 2 }}
                >
                  <div className=" blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg  w-12 h-12 flex justify-center items-center">
                    <i className="fas fa-tractor text-white xl:text-2xl lg:text-2xl text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="xl:p-8 lg:p-4 md:p-4 p-4">
                <h3 className="text-black font-semibold xl:text-xl lg:text-xl md:text-xl text-xl">
                  Conveying
                </h3>
                <p className="text-para xl:pt-2 lg:pt-2 pt-2 xl:text-base lg:text-base md:text-base text-base">
                Conveyor systems allow quick and efficient transportation for a wide variety of materials, making them popular in the material handling and packaging industries. They help streamline operations by reducing manual labor.
                </p>
                <a href="/contact">
                <button className="xl:px-8 xl:py-2 xl:mt-4 lg:px-4 lg:py-2 lg:mt-4 rounded-md borderblue text-green box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn more
                </button>
                </a>
              </div>
            </div>
          </div>

          <div className="h-full">
            <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
              <div className="relative ">
                <img
                  className="xl:w-12/12 lg:w-12/12 w-12/12"
                  src={mixing}
                  alt=""
                />
                <div
                  className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-8 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                  style={{ position: "relative", zIndex: 2 }}
                >
                  <div className=" blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg  w-12 h-12 flex justify-center items-center">
                    <i className="fas fa-blender text-white xl:text-2xl lg:text-2xl text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="xl:p-8 lg:p-4 md:p-4 p-4">
                <h3 className="text-blackk font-semibold xl:text-xl lg:text-xl md:text-xl text-xl">
                  Mixing
                </h3>
                <p className="text-para xl:pt-2 lg:pt-2 pt-2 xl:text-base lg:text-base text-base">
                  We offer low and high shear mixing equipment for various
                  applications. We efficiently mix powders, liquids, and more.
                  Our solutions ensure optimal blending efficiency with minimal
                  energy use.
                </p>

                <a href="/contact">
                <button className="xl:px-8 xl:py-2 xl:mt-4 lg:px-4 lg:py-2 lg:mt-8 md:mt-10 rounded-md borderblue text-blue box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn More
                </button>
                </a>
              </div>
            </div>
          </div>

          <div className="h-full">
            <div className="bg-white shadow-lg rounded-xl overflow-hidden relative h-full">
              <div className="relative ">
                <img
                  className="xl:w-12/12 lg:w-12/12 w-12/12"
                  src={thermal}
                  alt=""
                />
                <div
                  className="flex justify-end items-center xl:mr-8 xl:-mt-12 lg:mr-8 lg:-mt-12 md:-mt-8 mr-4 -mt-8"
                  style={{ position: "relative", zIndex: 2 }}
                >
                  <div className=" blue xl:p-10 lg:p-8 md:p-4 p-8 rounded-lg  w-12 h-12 flex justify-center items-center">
                    <i className="fas fa-fire text-white xl:text-2xl lg:text-2xl text-2xl"></i>
                  </div>
                </div>
              </div>
              <div className="xl:p-8 lg:p-4 md:p-4 p-4">
                <h3 className="text-blackk font-semibold xl:text-xl lg:text-xl md:text-xl">
                  Thermal Treatment
                </h3>
                <p className="text-para xl:pt-2 lg:pt-2 xl:text-base lg:text-base text-base pt-2">
                  Thermal treatment removes threats to consumer health,
                  deactivates enzymes, and preserves food quality. It ensures
                  safety, extends shelf life, and maintains nutritional value.
                </p>

                <a href="/contact">
                <button className="xl:px-8 xl:py-2 xl:mt-4 lg:px-4 lg:py-2 lg:mt-14 md:mt-16 rounded-md borderblue text-blue box xl:text-lg font-semibold px-2 py-1 mt-4">
                  Learn More
                </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="headerbg1 xl:pt-16 xl:pb-20 lg:pt-20 lg:pb-20 md:pt-16 md:pb-16 pt-12 pb-12">
        <p className="xl:text-xl lg:text-lg md:text-lg text-lg font-bold text-blue text-center uppercase">
          Services
        </p>
        <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black text-center pt-4">
          Comprehensive Solutions for<br></br> Your Every Need
        </h1>

        <div className="container mx-auto grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 xl:gap-6 lg:gap-4 gap-4 xl:px-0 px-4 xl:mt-16 lg:mt-16 md:mt-12 mt-8">
          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 rounded-lg flex items-center shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                {/* Image Section */}
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2 flex items-center">
                  <div
                    className="shadow-md flex justify-center items-center headerbg1"
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="w-10/12 object-contain"
                      src={basket}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black font-semibold text-xl pt-2">
                    Cheese Plants
                  </h3>
                  <p className="text-para mt-1">
                    Modern cheese plants use advanced machines for efficiency.
                  </p>

                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-10/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={eggs}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Dairy Plants
                  </h3>
                  <p className="text-para mt-1">
                    Modern dairy plants use advanced machines for quality.</p>
                    <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>
          

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={juice}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Juice
                  </h3>
                  <p className="text-para mt-1">
                    Juice manufacturing services use advanced processes for
                    purity and taste.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={bevarages}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Beverages
                  </h3>
                  <p className="text-para mt-1">
                    Beverage manufacturing uses advanced techniques for quality
                    and flavor.
                  </p>
                  <button
                   className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={waterplants}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Water Plants
                  </h3>
                  <p className="text-para mt-1">
                    Water plants use advanced filtration technology for purity
                    and safety.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={personalcare}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Personal Care
                  </h3>
                  <p className="text-para mt-1">
                    Personal care manufacturing uses advanced technology for
                    quality and safety.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={cosmetics}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Cosmetics
                  </h3>
                  <p className="text-para mt-1">
                    Cosmetics manufacturing uses advanced processes for quality
                    and innovation.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-10/12 w-10/12 object-contain"
                      src={culinary}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Culinary
                  </h3>
                  <p className="text-para mt-1">
                    Culinary manufacturing uses advanced techniques for taste
                    and quality.
                  </p>
                  <button
                   className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={chocolates}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Chocolate & Sweets
                  </h3>
                  <p className="text-para mt-1">
                    Chocolate and sweets manufacturing uses advanced techniques
                    for taste & quality.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={oil}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Edible Oil
                  </h3>
                  <p className="text-para mt-1">
                    Edible oil manufacturing uses advanced refining for purity
                    and quality.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={biscuits}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Confectioneries
                  </h3>
                  <p className="text-para mt-1">
                    Confectionery manufacturing uses advanced techniques for
                    taste and texture.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>
          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={medicine}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl text-xl pt-2">
                    Pharmaceuticals
                  </h3>
                  <p className="text-para mt-1">
                    Pharmaceutical manufacturing uses advanced technology for
                    safety and efficacy.
                  </p>
                  <button
                   className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>
        </div>

        {/* last two */}
        <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-6 gap-4 xl:px-64 xl:mt-6 lg:mt-6 mt-4 px-4 lg:px-40">
          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4 ">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={spices}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Spices
                  </h3>
                  <p className="text-para mt-1">
                    Spice manufacturing uses advanced processing for freshness
                    and flavor.
                  </p>
                  <button
                    className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>

          <div className="flex justify-center items-center rounded-lg">
            <div
              className="bg-white xl:h-200 lg:h-150 md:h-150 p-4 md:p-2 lg:p-2 rounded-lg flex items-center xl:p-4 shadow-lg relative"
              style={{
                backgroundImage: `url(${servicesbg2})`,
                width: "100%",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                borderLeft: "4px solid #224c96",
              }}
            >
              <div className="grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-5 grid-cols-1 xl:gap-0 lg:gap-4 gap-4">
                <div className="xl:col-span-2 lg:col-span-2 md:col-span-2">
                  <div
                    className="flex justify-center items-center headerbg1 shadow-md "
                    style={{
                      height: "120px",
                      width: "120px",
                      borderRadius: "9999px",
                    }}
                  >
                    <img
                      className="xl:w-8/12 lg:w-10/12 md:w-8/12 w-8/12 object-contain"
                      src={chemicals}
                      alt="Basket"
                    />
                  </div>
                </div>

                {/* Text Content */}
                <div className="xl:col-span-3 lg:col-span-3 md:col-span-3">
                  <h3 className="text-black textt font-semibold xl:text-xl  text-xl pt-2">
                    Chemical
                  </h3>
                  <p className="text-para mt-1">
                    Chemical manufacturing uses advanced techniques for safety
                    and efficiency.
                  </p>
                  <button
                   className=" text-blue  rounded-md mt-2"
                    style={{ outline: "none" }}
                    onClick={() => setButtonPopup(true)}
                  >
                    Know More ➜
                  </button>
                </div>
              </div>
            </div>

            {/* Popup Component */}
            <Popup trigger={buttonPopup} setTrigger={setButtonPopup} />
          </div>
        </div>
      </section>

      <section></section>

      <section className="bg-gradient xl:px-0 px-4 xl:pb-0 lg:pb-0 md:pb-16 pb-12">
        <div className="container mx-auto">
          <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 xl:gap-6">
            <div>
              <div className=" xl:pt-12 xl:pb-12 lg:pt-12 lg:pb-12  md:pt-12 pt-8">
                {/* Title */}
                <div className="relative inline-block ">
                  <span className=" text-blue  xl:text-xl lg:text-xl md:text-xl text-xl font-semibold rounded uppercase">
                    Why Choose Us
                  </span>
                </div>

                {/* Heading */}
                <h2 className="xl:text-4xl lg:text-2xl md:text-4xl text-2xl mt-4 xl:mt-0 lg:mt-0 md:mt-4 text-blackk font-bold mb-6">
                  Advancing Industries with Innovative Process Technologies
                </h2>

                {/* Grid Section (2x2 layout) */}
                <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 xl:mt-12 xl:gap-12 lg:mt-8 mt-8 lg:gap-4 gap-4 ">
                  {/* Box 1 */}
                  <div
                    className="bg-white shadow-xl xl:px-4 xl:py-10 lg:px-4 lg:py-8 md:px-0 md:py-12 px-0 py-8 rounded-lg flex flex-col items-center cursor-pointer transition-all duration-300"
                    onMouseEnter={() => setHovered1(true)}
                    onMouseLeave={() => setHovered1(false)}
                  >
                    <i className="fas fa-seedling text-4xl text-blue mb-2"></i>
                    {hovered1 ? (
                      <p className="text-sm text-center text-blackk">
                        Advancing Industries with<br></br> Innovative Solutions
                      </p>
                    ) : (
                      <p className="xl:text-xl font-semibold text-blackk">
                        Innovation
                      </p>
                    )}
                  </div>

                  {/* Box 2 */}
                  <div
                    className="bg-white shadow-xl xl:px-4 xl:py-10 lg:px-4 lg:py-8 md:px-0 md:py-12 px-0 py-8  rounded-lg flex flex-col items-center cursor-pointer transition-all duration-300"
                    onMouseEnter={() => setHovered2(true)}
                    onMouseLeave={() => setHovered2(false)}
                  >
                    <i className="fas fa-apple-alt text-4xl text-blue mb-2"></i>
                    {hovered2 ? (
                      <p className="text-sm text-center text-blackk">
                        Transforming Industries with<br></br> Advanced Solutions
                      </p>
                    ) : (
                      <p className="xl:text-xl font-semibold text-blackk">
                        Process Control
                      </p>
                    )}
                  </div>

                  {/* Box 3 */}
                  <div
                    className="bg-white shadow-xl xl:px-4 xl:py-10 lg:px-4 lg:py-8 md:px-0 md:py-12 px-0 py-8 rounded-lg flex flex-col items-center cursor-pointer transition-all duration-300"
                    onMouseEnter={() => setHovered3(true)}
                    onMouseLeave={() => setHovered3(false)}
                  >
                    <i className="fas fa-clipboard-list text-4xl text-blue mb-2"></i>
                    {hovered3 ? (
                      <p className="text-sm text-center text-blackk">
                        Innovative Process Technologies<br></br> for Modern
                        Solutions
                      </p>
                    ) : (
                      <p className="xl:text-xl font-semibold text-blackk">
                        Precision Solutions
                      </p>
                    )}
                  </div>

                  {/* Box 4 */}
                  <div
                    className="bg-white shadow-xl xl:px-4 xl:py-10 lg:px-4 lg:py-8 md:px-0 md:py-12 px-0 py-8 rounded-lg flex flex-col items-center cursor-pointer transition-all duration-300"
                    onMouseEnter={() => setHovered4(true)}
                    onMouseLeave={() => setHovered4(false)}
                  >
                    <i className="fas fa-leaf text-4xl text-blue mb-2"></i>
                    {hovered4 ? (
                      <p className="text-sm text-center text-blackk">
                        Creating value through<br></br> innovative processes
                      </p>
                    ) : (
                      <p className="xl:text-xl font-semibold text-blackk text-center">
                        Cutting-edge Techniques
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* 2nd grid  */}
            <div className="flex justify-end items-center xl:ml-8 lg:ml-4 md:ml-0 ml-0 xl:mt-0 lg:mt-0 md:mt-8 mt-6 ">
              <div className="xl:h-400 lg:h-300 md:h-380 h-200-px rounded-md " style={{
          backgroundImage: `url(${innovation})`,
          width: "100%",
          
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
>
                
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="headerbg1 xl:pt-16 xl:pb-20 lg:pt-20 lg:pb-20 md:pt-16 md:pb-16 pt-12 pb-12">
        <div className="container mx-auto xl:px-0 px-4">
          <p className="xl:text-xl lg:text-lg  md:text-lg text-lg font-bold text-blue  text-center uppercase">
            3 Easy Steps
          </p>
          <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black  text-center">
            Simple Steps for<br></br> Seamless Solutions
          </h1>

          <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 lg:gap-4 xl:gap-6 xl:mt-0 lg:mt-0 md:mt-0 xl:mt-16 lg:mt-16 md:mt-12 mt-12">
            <div className="">
              <div class="flex items-center justify-center   ">
                <div class="relative">
                  <div class="w-44 h-44 rounded-full  borderblue flex items-center justify-center">
                    <div class="w-40 h-40 rounded-full overflow-hidden">
                      <img
                        src={process1}
                        alt="Vegetables"
                        class="xl:w-12/12 lg:w-12/12 w-12/12 object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex justify-center items-center xl:ml-32 xl:-mt-12 lg:ml-24 lg:-mt-12 md:ml-20 md:-mt-8 ml-20 -mt-8">
                <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                  01
                </div>
              </div>

              <h1 className="xl:text-xl lg:text-xl md:text-xl text-xl pt-4 lg:pt-4 text-black font-semibold text-center xl:pt-6 textt">
                Choose products
              </h1>
              <p className="xl:text-base lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2 text-center">
                Discover a variety of innovative solutions designed to meet your
                specific needs
              </p>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-8">
              <div class="flex items-center justify-center">
                <div class="relative">
                  <div class="w-44 h-44 rounded-full  borderblue flex items-center justify-center">
                    <div class="w-40 h-40 rounded-full overflow-hidden">
                      <img
                        src={process2}
                        alt="Vegetables"
                        class="xl:w-12/12 lg:w-12/12 w-12/12 object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center xl:ml-32 xl:-mt-12 lg:ml-24 lg:-mt-12 md:ml-20 md:-mt-8 ml-20 -mt-8">
                <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                  02
                </div>
              </div>
              <h1 className="xl:text-xl lg:text-xl md:text-xl text-xl pt-4 lg:pt-4 text-black font-semibold text-center xl:pt-6 textt">
                Connect to store
              </h1>
              <p className="xl:text-base lg:text-sm lg:pt-2 text-base pt-2 text-para xl:pt-2 text-center">
                Seamlessly link with our store to explore and purchase your
                favorite products
              </p>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-8">
              <div class="flex items-center justify-center ">
                <div class="relative">
                  <div class="w-44 h-44 rounded-full  borderblue flex items-center justify-center">
                    <div class="w-40 h-40 rounded-full overflow-hidden">
                      <img
                        src={process3}
                        alt="Vegetables"
                        class="xl:w-12/12 lg:w-12/12 w-12/12 object-cover"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center xl:ml-32 xl:-mt-12 lg:ml-24 lg:-mt-12 md:ml-20 md:-mt-8 ml-20 -mt-8">
                <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                  03
                </div>
              </div>
              <h1 className="xl:text-xl lg:text-xl lg:pt-4 md:text-xl text-xl pt-4  text-black font-semibold text-center xl:pt-6 textt">
                Get your delivery
              </h1>
              <p className="xl:text-base lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2 text-center">
                Enjoy fast and reliable delivery right to your doorstep with our
                trusted service
              </p>
            </div>
          </div>
        </div>
      </section> */}

      <section className="headerbg1 xl:pt-16 xl:pb-20 lg:pt-20 lg:pb-20 md:pt-12 md:pb-16 pt-12 pb-12">
        <div className="container mx-auto xl:px-0 px-4">
          <p className="xl:text-xl lg:text-lg  md:text-lg text-lg font-bold text-blue  text-center uppercase">
            3 Easy Steps
          </p>
          <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl font-bold text-black  text-center">
            Simple Steps for<br></br> Seamless Solutions
          </h1>

          <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 lg:gap-4 xl:gap-6 xl:mt-0 lg:mt-0 md:mt-0 xl:mt-16 lg:mt-16 md:mt-12 mt-12">
            <div>
              <div
                className="xl:h-200 lg:h-150 md:h-200 h-200-px"
                style={{
                  backgroundImage: `url(${service1})`,
                  width: "80%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="flex justify-end">
                <div className="bg-white rounded-md xl:p-4 lg:p-4 p-4  xl:-mt-16 xl:w-8/12 lg:w-10/12 lg:-mt-16 md:w-10/12 md:-mt-16 w-10/12 -mt-12">
                  <div className="flex xl:gap-4 lg:gap-2 md:gap-4 gap-2">
                    <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                      01
                    </div>
                    <h1 className="xl:text-xl lg:text-lg md:text-base text-xl  text-black font-semibold text-center  textt xl:pt-2 pt-2">
                      Choose products
                    </h1>
                  </div>
                  <p className="xl:text-base lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2 text-center">
                    Discover a variety of innovative solutions designed to meet
                    your specific needs
                  </p>
                </div>
              </div>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-8">
              <div
                className="xl:h-200 lg:h-150 md:h-200 h-200-px"
                style={{
                  backgroundImage: `url(${service2})`,
                  width: "80%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="flex justify-end">
                <div className="bg-white rounded-md xl:p-4 lg:p-4 p-4  xl:-mt-16 xl:w-8/12 lg:w-10/12 lg:-mt-16 md:w-10/12 md:-mt-16 w-10/12 -mt-12">
                  <div className="flex xl:gap-4 lg:gap-2 md:gap-4 gap-2">
                    <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                      02
                    </div>
                    <h1 className="xl:text-xl lg:text-lg md:text-xl text-xl  text-black font-semibold text-center  textt xl:pt-2 pt-2">
                      Connect to store
                    </h1>
                  </div>
                  <p className="xl:text-base lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2 text-center">
                    Seamlessly link with our store to explore and purchase your
                    favorite products
                  </p>
                </div>
              </div>
            </div>

            <div className="xl:mt-0 lg:mt-0 md:mt-0 mt-8">
              <div
                className="xl:h-200 lg:h-150 md:h-200 h-200-px"
                style={{
                  backgroundImage: `url(${service3})`,
                  width: "80%",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
              <div className="flex justify-end">
                <div className="bg-white rounded-md xl:p-4 lg:p-4 p-4  xl:-mt-16 xl:w-8/12 lg:w-10/12 lg:-mt-16 md:w-10/12 md:-mt-16 w-10/12 -mt-12">
                  <div className="flex xl:gap-4 lg:gap-2 md:gap-4 gap-2">
                    <div class=" xl:w-12 xl:h-12 w-12 h-12 blue text-white text-lg font-bold flex items-center justify-center rounded-full shadow-lg z-10">
                      03
                    </div>
                    <h1 className="xl:text-xl lg:text-lg md:text-xl text-xl  text-black font-semibold text-center  textt xl:pt-2 pt-2">
                      Get your delivery
                    </h1>
                  </div>
                  <p className="xl:text-base lg:text-sm text-base pt-2 lg:pt-2 text-para xl:pt-2 text-center">
                    Enjoy fast and reliable delivery right to your doorstep with
                    our trusted service
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </section>
  );
};

export default Service;
